import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";
import { initI18n } from "./translation/config";

const root = ReactDOM.createRoot(document.getElementById("root"));
initI18n().then(() => {
  root.render(
    <React.Fragment>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.Fragment>,
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
